import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const scrollBehavior = function(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    const position = {};

    if (to.hash) {
      position.selector = to.hash;
      if (to.hash === "#anchor2") {
        position.offset = { y: 100 };
      }
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position;
      }
      return false;
    }

    return new Promise((resolve) => {
      if (to.matched.some((m) => m.meta.scrollToTop)) {
        position.x = 0;
        position.y = 0;
        resolve(position);
      }

      this.app.$root.$once("triggerScroll", () => {
        resolve(position);
      });
    });
  }
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "Home" */ "../views/Home.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/newupdates",
    name: "NewUpdates",
    component: () =>
      import(/* webpackChunkName: "NewUpdates" */ "../views/NewUpdates.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/privacy.html",
    name: "PrivacyHtml",
    component: () =>
      import(/* webpackChunkName: "Privacy" */ "../views/Privacy.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () =>
      import(/* webpackChunkName: "Privacy" */ "../views/Privacy.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/terms-mobile",
    name: "TermsMobile",
    component: () =>
      import(/* webpackChunkName: "TermsMobile" */ "../views/TermsMobile.vue"),
    meta: { scrollToTop: true },
  },

  {
    path: "/articles",
    name: "Articles",
    component: () =>
      import(/* webpackChunkName: "Articles" */ "../views/Articles.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/kids",
    name: "Kids",
    component: () => import(/* webpackChunkName: "Kids" */ "../views/Kids.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/watchlist",
    name: "Watchlist",
    component: () =>
      import(/* webpackChunkName: "Watchlist" */ "../views/Watchlist.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/mustwatch",
    name: "MustWatch",
    component: () =>
      import(/* webpackChunkName: "MustWatch" */ "../views/MustWatch.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/recommended/:id/:slug",
    name: "Recommended",
    component: () =>
      import(/* webpackChunkName: "Recommended" */ "../views/Recommended.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/articles/:id/:slug",
    name: "ArticlesDetail",
    component: () =>
      import(
        /* webpackChunkName: "ArticlesDetail" */ "../views/Articles/_slug.vue"
      ),
    meta: {
      scrollToTop: true,
    },
  },
  {
    path: "/reviews/:id/:slug",
    name: "ReviewsDetail",
    component: () =>
      import(
        /* webpackChunkName: "ReviewDetail" */ "../views/Review/_slug.vue"
      ),
    meta: {
      scrollToTop: true,
    },
  },
  {
    path: "/detail/:id/:slug",
    name: "Detail",
    component: () =>
      import(/* webpackChunkName: "Detail" */ "../views/Detail/_slug.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/detail/:id",
    name: "Detail2",
    component: () =>
      import(/* webpackChunkName: "Detail" */ "../views/Detail/_slug.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "About" */ "../views/About.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/loginApple",
    name: "loginApple",
    component: () =>
      import(/* webpackChunkName: "loginApple" */ "../views/loginApple.vue"),

    meta: { scrollToTop: true },
  },
  {
    path: "/termsServices",
    name: "TermsServices",
    //component: TermsServices,

    component: () =>
      import(
        /* webpackChunkName: "TermsServices" */ "../views/TermsServices.vue"
      ),

    meta: { scrollToTop: true },
  },
  {
    path: "/sm",
    name: "SiteMap",
    component: () =>
      import(/* webpackChunkName: "SiteMap" */ "../views/SiteMap.vue"),

    meta: { scrollToTop: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior,

  routes,
});

router.beforeEach((toRoute, fromRoute, next) => {
  // window.document.title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title : 'Home';
  if (
    toRoute.name === "ArticlesDetail" ||
    toRoute.name === "ReviewsDetail" ||
    toRoute.name === "Recommended"
  ) {
    const searchRegExp = /-/g;
    const replaceWith = " ";
    const slug = toRoute.params.slug.replace(searchRegExp, replaceWith);

    window.document.title = `${slug} - OTT Watchlist`;
  } else if (toRoute.name === "Detail") {
    const searchRegExp = /-/g;
    const replaceWith = " ";
    const slug = toRoute.params.slug.replace(searchRegExp, replaceWith);

    window.document.title = `${slug} - Where To Watch Online - OTT Watchlist`;
  }

  next();
});

export default router;
